import { strings as errorStrings } from '@components/ErrorComponent/strings';

const strings = {
  labels: {
    dialog: {
      exitWarning: {
        title: 'Discard unsaved changes?',
        body: 'This cannot be undone.',
        primaryAction: 'Discard Changes',
        secondaryAction: 'Cancel',
      },
    },
    editContacts: {
      header: 'Edit Contact Methods',
      primaryAction: 'Save',
      secondaryAction: 'Cancel',
      successToast: {
        title: 'All Contacts Saved Successfully',
      },
      errorToast: {
        title: 'Some Contacts could not be Saved',
        message: errorStrings.retryMessage,
      },
    },
    toasts: {
      contactSupportActionText: 'Contact Support',
      errorBody:
        'Check your internet connectivity and try again. If the problem persists, log an issue with support.',
    },
    contactSupport: {
      subjectText: 'CCPro Support Request',
    },
  },
} as const;

export default strings;
